import { render, staticRenderFns } from "./PaymentPendingPackage.vue?vue&type=template&id=f784eadc&scoped=true"
import script from "./PaymentPendingPackage.vue?vue&type=script&lang=js"
export * from "./PaymentPendingPackage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPendingPackage.vue?vue&type=style&index=0&id=f784eadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f784eadc",
  null
  
)

export default component.exports